import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Tab,
  Tabs,
  Select,
  MenuItem,
  IconButton,
  useTheme,
  useMediaQuery,
  styled,
  LinearProgress,
  Card,
  CardContent,
  CardHeader,
  ButtonGroup,
} from "@mui/material";
import {
  ArrowUpward,
  ArrowDownward,
  Info,
  FileDownload,
  SentimentSatisfiedAlt,
  RecordVoiceOver,
  CheckCircle,
  Timer,
} from "@mui/icons-material";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import Grid from "@mui/material/Grid2";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import CommonKpisBox from "../../../components/CommonKpisBox";
import Sentiment from "./Sentiment";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import CommonFilter from "../../../components/CommonFilter";
import Loader from "../../../components/AnimatedLoader";
import { jwtDecode } from "jwt-decode";
import { palette, theme  as colorTheme } from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";


const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;




const improvements = [
  {
    title: "Reduce Silence Duration",
    description:
      "Your average silence duration has increased by 0.2 min. Try to minimize hold times and have information ready.",
    link: "View Training",
    linkHref: "#",
  },
  {
    title: "Improve Tone & Manner",
    description:
      "Your tone score is 7.8/10, which is below your average in other parameters. Focus on voice modulation and enthusiasm.",
    link: "View Examples",
    linkHref: "#",
  },
  {
    title: "Enhance Product Knowledge",
    description:
      "Take advantage of new product training resources to improve your confidence and reduce callbacks.",
    link: "Access Resources",
    linkHref: "#",
  },
];

const MyKpis = () => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [kpisData, setKpisData] = useState();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";

  const isFilter = { date: true, filter: false };
  const [payloadData, setPayloadData] = useState();
  const [loading, setLoading] = useState(true);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const cardsData = [
    {
      title: "Avg. Sentiment Score",
      value: kpisData?.overallSentimentScore
        ? `${Math.round(kpisData?.overallSentimentScore)}%`
        : 0,
      icon: "SentimentSatisfiedAlt",
      iconBgColor: "#DCFCE7",
      iconColor: positive,
      trend: {
        direction: "up",
        value: "0.5",
        note: "vs last week",
      },
    },
    {
      title: "Talk Ratio",
      value: "42:58",
      icon: "RecordVoiceOver",
      iconBgColor: "#e3f2fd",
      iconColor: primary,
      trend: {
        direction: "down",
        value: "3%",
        note: "less agent talk",
      },
    },
    {
      title: "Resolution Rate",
      value: "91%",
      icon: "CheckCircleOutlineIcon",
      iconBgColor: "#F3E8FF",
      iconColor: positive,
      trend: {
        direction: "up",
        value: "4%",
        note: "vs last week",
      },
    },
    {
      title: "Avg. Silence Duration",
      value: "1.4 min",
      icon: "Timer",
      iconBgColor: "#FFEDD5",
      iconColor: neutral,
      trend: {
        direction: "down",
        value: "0.2 min",
        note: "vs last week",
      },
    },
  ];
  useEffect(() => {
    fetchKpisDetails();
  }, [payloadData]);
  const fetchKpisDetails = async () => {
    const today = new Date();
    const data = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
      agentId: decodedToken?.agentId || "",
    };
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.agentKpis,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setKpisData(res?.data?.data);
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Dashboard fetch error:", error);
      }
    }
  };
  return (
    <>
      {/* <Box
        sx={{
          ml: {
          xs: "0px",
          md: "230px",
        },
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2.5,
        }}
      >
       
      </Box> */}

      <ParentWrapper>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexDirection: isMobile ? "column" : "row",
            mb: 3,
            gap: 2,
          }}
        >
          <Box>
            {/* <Typography
              variant="h5"
              sx={{
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: 700,
              }}
              gutterBottom
            >
              My KPIs
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Track and improve your key performance indicators
            </Typography> */}

             {/* <Header title={"My KPIS"} subHeading={"Track and improve your key performance indicators"} /> */}
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              gap: 2,
              alignSelf: isMobile ? "flex-end" : "center",
            }}
          >
            <Select
              value={timeFilter}
              onChange={(e) => setTimeFilter(e.target.value)}
              size="small"
              sx={{
                minWidth: 150,
                bgcolor: "background.paper",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ccc",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#6366F1",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#999",
                },
              }}
            >
              <MenuItem value="Last 7 Days">Last 7 Days</MenuItem>
              <MenuItem value="Last 30 Days">Last 30 Days</MenuItem>
              <MenuItem value="Last 90 Days">Last 90 Days</MenuItem>
            </Select>
            <Button
              variant="contained"
              startIcon={<FileDownload />}
              sx={{
                bgcolor: "#6366F1",
                "&:hover": {
                  backgroundColor: "#3C3EBB",
                },
              }}
            >
              Export Report
            </Button>
            
          </Box> */}
          {/* <KpisFilter setMyKpiData={setKpisData} /> */}
          <CommonFilter
            setPayloadData={setPayloadData}
            storageName={"AgentKpis"}
            isFilter={isFilter}
          />
        </Box>
        {loading ? (
          <Loader />
        ) : (
          <>
            <Paper
              sx={{
                p: 1.5,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", md: "center" },
                gap: { xs: 1, md: 0 },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#F0F1FE",
                    borderRadius: "50%",
                    width: 80,
                    height: 80,
                  }}
                >
                  <Typography
                    variant="h4"
                    component="div"
                    fontWeight="bold"
                    color={primary}
                  >
                    {kpisData?.averageOverallParameterScore
                      ? Math.round(kpisData?.averageOverallParameterScore)
                      : 0}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    component="div"
                    fontWeight="bold"
                    fontSize={18}
                  >
                    Overall Performance Score
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Based on{" "}
                    <span style={{ color: primary, fontWeight: 600 }}>
                      {kpisData?.processedCalls}
                    </span>{" "}
                    processed calls
                  </Typography>
                </Box>
              </Box>
              {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ArrowUpward sx={{ color: "success.main", mr: 0.5 }} />
            <Typography
              variant="body2"
              color="success.main"
              fontWeight="medium"
            >
              4 points
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
              vs previous period
            </Typography>
            <IconButton size="small">
              <InfoOutlinedIcon sx={{ color: "#6366F1", fontSize: 20 }} />
            </IconButton>
          </Box> */}
            </Paper>

            <Paper
              elevation={1}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  variant={isMobile ? "scrollable" : "standard"}
                  scrollButtons={isMobile ? "auto" : false}
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: primary,
                      height: "3px",
                      color: primary,
                    },
                  }}
                >
                  {/* <Tab
                sx={{
                  "&.Mui-selected": {
                    color: "#6366F1",
                  },
                }}
                label="Overview"
              /> */}
                  <Tab
                    sx={{
                      "&.Mui-selected": {
                        color: primary,
                      },
                    }}
                    label="Sentiment Analysis"
                  />
                </Tabs>
              </Box>

              {/* {tabValue === 0 && <Overview />} */}
              {tabValue === 0 && <Sentiment sentimentData={kpisData} />}
            </Paper>
            {/* <Paper
          elevation={1}
          sx={{
            p: 2,
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            fontWeight="600"
            fontSize={"1.125rem"}
          >
            Improvement Opportunities
          </Typography>
          <Grid
            container
            spacing={2}
            sx={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {improvements?.map((item, index) => (
              <Grid
                item
                size={{ xs: 12, sm: 6, md: 4 }}
                key={index}
                sx={{ display: "flex" }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    flex: 1,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#F0F1FE",
                    border:
                      "1px solid rgb(219 234 254 / var(--tw-border-opacity, 1))",
                    display: "flex",
                    gap: 1,
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    className="text-blue-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    style={{ color: "#6366F1" }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5,
                    }}
                  >
                    <Typography variant="body1" fontWeight={500}>
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      fontSize={"0.75rem"}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Paper> */}
          </>
        )}
      </ParentWrapper>
    </>
  );
};

export default MyKpis;
